import { render, staticRenderFns } from "./medalList.vue?vue&type=template&id=36972a83&scoped=true"
import script from "./medalList.vue?vue&type=script&lang=js"
export * from "./medalList.vue?vue&type=script&lang=js"
import style0 from "./medalList.vue?vue&type=style&index=0&id=36972a83&prod&lang=scss&scoped=true"
import style1 from "./medalList.vue?vue&type=style&index=1&id=36972a83&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36972a83",
  null
  
)

export default component.exports